export * from './functions/safari';
